/*!
 * devextreme-angular
 * Version: 26.1.6
 * Build date: Fri Oct 16 2026
 *
 * Copyright (c) 2012 - 2026 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/DevExtreme
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';




import type { SummaryType } from 'devextreme/common/grids';
import type { Format } from 'devextreme/common/core/localization';

import {
    DxIntegrationModule,
    NestedOptionHost,
} from 'devextreme-angular/core';
import { CollectionNestedOption } from 'devextreme-angular/core';

import { PROPERTY_TOKEN_groupItems } from 'devextreme-angular/core/tokens';

@Component({
    selector: 'dxi-data-grid-group-item',
    template: '',
    styles: [''],
    imports: [ DxIntegrationModule ],
    providers: [
        NestedOptionHost,
        {
           provide: PROPERTY_TOKEN_groupItems,
           useExisting: DxiDataGridGroupItemComponent,
        }
    ]
})
export class DxiDataGridGroupItemComponent extends CollectionNestedOption {
    @Input()
    get alignByColumn(): boolean {
        return this._getOption('alignByColumn');
    }
    set alignByColumn(value: boolean) {
        this._setOption('alignByColumn', value);
    }

    @Input()
    get column(): string | undefined {
        return this._getOption('column');
    }
    set column(value: string | undefined) {
        this._setOption('column', value);
    }

    @Input()
    get customizeText(): ((itemInfo: { value: string | number | Date, valueText: string }) => string) {
        return this._getOption('customizeText');
    }
    set customizeText(value: ((itemInfo: { value: string | number | Date, valueText: string }) => string)) {
        this._setOption('customizeText', value);
    }

    @Input()
    get displayFormat(): string | undefined {
        return this._getOption('displayFormat');
    }
    set displayFormat(value: string | undefined) {
        this._setOption('displayFormat', value);
    }

    @Input()
    get name(): string | undefined {
        return this._getOption('name');
    }
    set name(value: string | undefined) {
        this._setOption('name', value);
    }

    @Input()
    get showInColumn(): string | undefined {
        return this._getOption('showInColumn');
    }
    set showInColumn(value: string | undefined) {
        this._setOption('showInColumn', value);
    }

    @Input()
    get showInGroupFooter(): boolean {
        return this._getOption('showInGroupFooter');
    }
    set showInGroupFooter(value: boolean) {
        this._setOption('showInGroupFooter', value);
    }

    @Input()
    get skipEmptyValues(): boolean {
        return this._getOption('skipEmptyValues');
    }
    set skipEmptyValues(value: boolean) {
        this._setOption('skipEmptyValues', value);
    }

    @Input()
    get summaryType(): string | SummaryType | undefined {
        return this._getOption('summaryType');
    }
    set summaryType(value: string | SummaryType | undefined) {
        this._setOption('summaryType', value);
    }

    @Input()
    get valueFormat(): Format | undefined {
        return this._getOption('valueFormat');
    }
    set valueFormat(value: Format | undefined) {
        this._setOption('valueFormat', value);
    }


    protected get _optionPath() {
        return 'groupItems';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }



    ngOnDestroy() {
        this._deleteRemovedOptions(this._fullOptionPath());
    }

}

@NgModule({
  imports: [
    DxiDataGridGroupItemComponent
  ],
  exports: [
    DxiDataGridGroupItemComponent
  ],
})
export class DxiDataGridGroupItemModule { }
